module.exports = __webpack_public_path__ + "static/media/truck.b2ed0e24.svg";